import  { useContext, useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation } from "react-router-dom";
import { LoginContext } from "../AuthContext/LoginContext";
import { TypingAnimation } from "../components/magicui/typing-animation.tsx";

const MasterLayout = ({ children }) => {
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation(); // Hook to get the current route
  const { logout, hasPermission } = useContext(LoginContext);
  
  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
            ? "sidebar sidebar-open"
            : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type='button'
          className='sidebar-close-btn'
        >
          <Icon icon='radix-icons:cross-2' />
        </button>
     
        <div className='sidebar-menu-area'>
         
          <ul className='sidebar-menu ' id='sidebar-menu'>
            <Link to='/' className='py-4 d-flex justify-content-center'>
              <div className="flex items-center">
                <img 
                  src={process.env.PUBLIC_URL + "/assets/images/govpklogo1.png"}
                  alt="Logo" 
                  className="mx-4 "  
                  style={{ width: '150px', height: 'auto' }} 
                />
                
              </div>
            </Link>
            
            <hr className="my-3" style={{ height: "3px", backgroundColor: "white" }} />
          
            
             {hasPermission('dashboard', 'view') && (
              <li className="py-10">
                <NavLink
                  to='/dashboard'
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:view-dashboard" className="menu-icon" /> 
                  <span>Dashboard</span>
                </NavLink>
              </li>
            )}

             {hasPermission('reports', 'view') && (
              <li className='dropdown '>
                <Link to='#'>
                  <Icon
                    icon='mdi:file-document'  
                    className='menu-icon'
                  />
                  <span>Reports</span>
                </Link>
                <ul className='sidebar-submenu'>
                  
                  {hasPermission('reports', 'view') && (
                    <li className="py-6">
                      <NavLink
                        to='/reports/activity' 
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className='ri-circle-fill circle-icon text-success-main w-auto' />
                        Activity 
                      </NavLink>
                    </li>
                  )}
                   {hasPermission('reports', 'view') && (
                    <li className="py-6">
                      <NavLink
                        to='/reports/district-wise' 
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className='ri-circle-fill circle-icon text-success-main w-auto' />
                        District Wise 
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}
            
       
              {hasPermission('plantations', 'view') && (
                <li className="py-10">
                  <NavLink
                    to='/plantations/list'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="mdi:tree" className="menu-icon" />
                    <span>Plantations</span>
                  </NavLink>
                </li>
              )}
              {hasPermission('your_activity', 'view') && (
                <li className="py-10">
                  <NavLink
                    to='/plantations/your-activity'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="mdi:clipboard-list" className="menu-icon" /> {/* User icon */}
                    <span>Your Activity</span>
                  </NavLink>
                </li>
              )}
                {/* {hasPermission('plant_va', 'view') && (
                <>
            
                  <li className="py-10">
                    <NavLink
                      to='/plant/virtual-assistant'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                    
                    <Icon icon="mdi:forest" className="menu-icon" />
                    <span>Plant VA</span>
                    </NavLink>
                  </li>
                </>
              )}  */}
              {hasPermission('dep_activity', 'view') && (
                <li className="py-10">
                  <NavLink
                    to='/plantations/departmental-activity'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="mdi:account-group" className="menu-icon" /> {/* Group icon */}
                    <span>Department Activity</span>
                  </NavLink>
                </li>
              )}
              {hasPermission('provisional_activity', 'view') && (
                <li className="py-10">
                  <NavLink
                    to='/plantations/provisional-activity'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="mdi:account-group" className="menu-icon" /> {/* Group icon */}
                    <span>Provisional Activity</span>
                  </NavLink>
                </li>
              )}

            {hasPermission('users', 'view') && (
              <>
              
                <li className="py-10">
                  <NavLink
                    to='/users/list'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="mdi:account" className="menu-icon" />
                    <span>Users</span>
                  </NavLink>
                </li>
              </>
            )} 
           
              <>
                
                <li className="py-10">
                  <Link
                    to='/change-password'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="solar:user-linear" className="menu-icon" />
                    <span>Change Password</span>
                  </Link>
                </li>
                <li className="py-10">
                  <Link
                    to='/contact-us'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="solar:phone-linear" className="menu-icon" />
                    <span>Contact Us</span>
                  </Link>
                </li>
              </>
          
              <>
                
                <li className="py-10">
                  <Link
                    onClick={logout}
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="lucide:power" className="menu-icon" />
                    <span>Log Out</span>
                  </Link>
                </li>
              </>
            {/* )}  */}
            
          
           
             
            
            
          </ul>
        
      </div>
       
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
       <div
        className="navbar-header"
        style={{
          position: 'relative', // needed for absolute positioning of video and overlay
          overflow: 'hidden',   // to clip video if needed
        }}
      >
        {/* Video background */}
        <video
          autoPlay
          loop
          muted
          playsInline
          src={process.env.PUBLIC_URL + "/assets/videos/video_forest_top_bar.mp4"}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: 0,
          }}
        />

        {/* Green tint overlay */}
        


          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 255, 0, 0.03)', // Green overlay with transparency
              zIndex: 1,
            }}
          ></div>
          <div style={{ position: 'relative', zIndex: 2 }}>
            <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-4'>
                <button
                  type='button'
                  className='sidebar-toggle'
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon='iconoir:arrow-right'
                      className='icon text-2xl non-active'
                    />
                  ) : (
                    <Icon
                      icon='heroicons:bars-3-solid'
                      className='icon text-2xl non-active '
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type='button'
                  className='sidebar-mobile-toggle'
                >
                  <Icon icon='heroicons:bars-3-solid' className='icon' />
                </button>
              </div>
            </div>
            <div className="col-auto">
                        <div className="d-flex flex-wrap align-items-center">
                          <label className="d-flex align-items-center" style={{ cursor: "pointer" }}>
                            <TypingAnimation 
                              startOnView={true}
                              style={{
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 700,
                                fontSize: "35px",
                                background: "linear-gradient(to right, #eebb12ff, #ffc60bff, #ffcc00ff)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                backgroundClip: "text",
                              }}
                            >
                              PAKISTAN PLANTATION & GROWTH MONITORING SYSTEM
                            </TypingAnimation>
                          </label>
                        </div>
                </div>
            <div className='col-auto'>
              
              <div className='d-flex flex-wrap align-items-center gap-3'>
             
                {/* <div className='dropdown'>
                  <button
                    className='has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center'
                    type='button'
                    data-bs-toggle='dropdown'
                  >
                    <Icon
                      icon='iconoir:bell'
                      className='text-primary-light text-xl'
                    />
                  </button>
                  <div className='dropdown-menu to-top dropdown-menu-lg p-0' style={{ position: 'relative', zIndex: 99999 }}>
                    <div className='m-16 py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
                      <div>
                        <h6 className='text-lg text-primary-light fw-semibold mb-0'>
                          Notifications
                        </h6>
                      </div>
                      <span className='text-primary-600 fw-semibold text-lg w-40-px h-40-px rounded-circle bg-base d-flex justify-content-center align-items-center'>
                        05
                      </span>
                    </div>
                    <div className='max-h-400-px overflow-y-auto scroll-sm pe-4'>
                      <Link
                        to='#'
                        className='px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between'
                      >
                        <div className='text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'>
                          <span className='w-44-px h-44-px bg-success-subtle text-success-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0'>
                            <Icon
                              icon='bitcoin-icons:verify-outline'
                              className='icon text-xxl'
                            />
                          </span>
                          <div>
                            <h6 className='text-md fw-semibold mb-4'>
                              Congratulations
                            </h6>
                            <p className='mb-0 text-sm text-secondary-light text-w-200-px'>
                              Your profile has been Verified. Your profile has
                              been Verified
                            </p>
                          </div>
                        </div>
                        <span className='text-sm text-secondary-light flex-shrink-0'>
                          23 Mins ago
                        </span>
                      </Link>
                      <Link
                        to='#'
                        className='px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between bg-neutral-50'
                      >
                        <div className='text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'>
                          <span className='w-44-px h-44-px bg-success-subtle text-success-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0'>
                            <img
                              src='assets/images/notification/profile-1.png'
                              alt=''
                            />
                          </span>
                          <div>
                            <h6 className='text-md fw-semibold mb-4'>
                              Ronald Richards
                            </h6>
                            <p className='mb-0 text-sm text-secondary-light text-w-200-px'>
                              You can stitch between artboards
                            </p>
                          </div>
                        </div>
                        <span className='text-sm text-secondary-light flex-shrink-0'>
                          23 Mins ago
                        </span>
                      </Link>
                      <Link
                        to='#'
                        className='px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between'
                      >
                        <div className='text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'>
                          <span className='w-44-px h-44-px bg-info-subtle text-info-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0'>
                            AM
                          </span>
                          <div>
                            <h6 className='text-md fw-semibold mb-4'>
                              Arlene McCoy
                            </h6>
                            <p className='mb-0 text-sm text-secondary-light text-w-200-px'>
                              Invite you to prototyping
                            </p>
                          </div>
                        </div>
                        <span className='text-sm text-secondary-light flex-shrink-0'>
                          23 Mins ago
                        </span>
                      </Link>
                      <Link
                        to='#'
                        className='px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between bg-neutral-50'
                      >
                        <div className='text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'>
                          <span className='w-44-px h-44-px bg-success-subtle text-success-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0'>
                            <img
                              src='assets/images/notification/profile-2.png'
                              alt=''
                            />
                          </span>
                          <div>
                            <h6 className='text-md fw-semibold mb-4'>
                              Annette Black
                            </h6>
                            <p className='mb-0 text-sm text-secondary-light text-w-200-px'>
                              Invite you to prototyping
                            </p>
                          </div>
                        </div>
                        <span className='text-sm text-secondary-light flex-shrink-0'>
                          23 Mins ago
                        </span>
                      </Link>
                      <Link
                        to='#'
                        className='px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between'
                      >
                        <div className='text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'>
                          <span className='w-44-px h-44-px bg-info-subtle text-info-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0'>
                            DR
                          </span>
                          <div>
                            <h6 className='text-md fw-semibold mb-4'>
                              Darlene Robertson
                            </h6>
                            <p className='mb-0 text-sm text-secondary-light text-w-200-px'>
                              Invite you to prototyping
                            </p>
                          </div>
                        </div>
                        <span className='text-sm text-secondary-light flex-shrink-0'>
                          23 Mins ago
                        </span>
                      </Link>
                    </div>
                    <div className='text-center py-12 px-16'>
                      <Link
                        to='#'
                        className='text-primary-600 fw-semibold text-md'
                      >
                        See All Notification
                      </Link>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className='dashboard-main-body'>
          {children}
          </div>

        {/* Footer section */}
       <footer className='d-footer py-3  bg-gradient-dark border-top'>
        <div className='container'>
          <div className='row justify-content-between align-items-center text-center'>
            {/* Logo on the left */}
            <div className='col-auto'>
              <img 
                src={process.env.PUBLIC_URL + "/assets/images/gislogo.png"}
                alt="Logo" 
                className="mx-4"  
                style={{ width: '250px', height: 'auto' }} 
              />
            </div>
            
            {/* Copyright Text and Developer Credit on the right */}
            <div className='col text-end '>
              <p className='mb-0  text-white fs-6'>
                © {new Date().getFullYear()} All Rights Reserved.
              </p>
              <p className='mb-0  fs-6 text-white'>
              <span className='fw-bold'> Powered by </span> <span className='text-success-400 fw-bold'>GIS Lab | Forestry & Wildlife Department | Government of Punjab, Pakistan.</span>
              </p>
            </div>
          </div>
        </div>
      </footer>

      </main>
    </section>
  );
};

export default MasterLayout;
